<template>
  <div>
        <div :style="{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left'
        }">
            
            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px;  top: 5px; position: relative; ">
                    <span type="label">Reciept #</span>
                </div>
                <div>
                    <el-input @focus="$event.target.select()"
                    disabled
                    placeholder="Auto-Generated"
                    v-model="$store.state.productionItemIssue.props.challan_number"
                    type="number"
                    size="small"
                    style="width: 250px;">
                </el-input>
                </div>

            </div>

            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px;  top: 5px; position: relative; ">
                    <span type="label">Work-Order#</span>
                </div>
                <div>
                    <el-select 
                        @change="loadSearchedItem"
                        default-first-option
                        placeholder="order# or work-order number"
                        remote
                        :remote-method="searchWorkOrderAutoComplete"
                        size="small"
                        :loading="$store.getters.getLoadingState"
                        v-model="$store.state.productionItemIssue.props.work_order_number" 
                        filterable 
                        style="text-align: left; width: 250px; margin-top: 0px;">
                        <el-option
                            v-for="(data, index) in $store.getters.getProductionWorkOrderAutocompleteList"
                            :key="index"
                            :label="data.work_order_number"
                            :value="data">
                            <div>
                                <span style="float: left">
                                    {{data.work_order_number}}
                                </span>
                            </div>
                        </el-option>
                    </el-select>
                </div>

            </div>
            
            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px;  top: 5px; position: relative; ">
                    <span type="label">From Store</span>
                </div>
                <div>
                    <el-select 
                        id="store_id"
                        size="small"
                        v-model="$store.state.productionItemIssue.props.store_id" 
                        filterable 
                        style="width: 250px; text-align: left;">
                        <el-option
                            v-for="(data, index) in $store.getters.getAccessibleStoreList"
                            :key="index"
                            :label="data.store_name"
                            :value="data.id">
                            <span style="float: left" v-html="data.store_name"></span>
                        </el-option>
                    </el-select>
                </div>

            </div>

            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px;  top: 5px; position: relative; ">
                    <span type="label">Date Of Issue</span>
                </div>
                <div>
                    <el-date-picker
                        size="small"
                        type="date"
                        v-model="$store.state.productionItemIssue.props.issue_date"
                        style="width: 250px;" 
                        value-format="yyyy-MM-dd"
                        format="MMM dd yyyy">
                    </el-date-picker>
                </div>

            </div>
            
            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px;  top: 5px; position: relative;">
                    <span type="label">Issued To Employee</span>
                </div>
                <div>
                    <el-select 
                        id="sourced_by_staff_id"
                        size="small"
                        v-model="$store.state.productionItemIssue.props.issued_to_staff_id" 
                            filterable 
                            style="width: 250px; text-align: left;">
                        <el-option
                            v-for="(data, index) in $store.getters.getEmployeeMasterList.filter(t => t.active && t.is_production_member)"
                            :key="index"
                            :label="data.staff_name"
                            :value="data.id">
                            <span style="float: left" v-html="data.staff_name"></span>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px;  top: 5px; position: relative;">
                    <span type="label">Issued By Employee</span>
                </div>
                <div>
                    <el-select 
                        id="delivered_by_staff_id"
                        size="small"
                        v-model="$store.state.productionItemIssue.props.issued_by_staff_id" filterable style="width: 250px; text-align: left;">
                        <el-option
                            v-for="(data, index) in $store.getters.getEmployeeMasterList.filter((element) => element.active)"
                            :key="index"
                            :label="data.staff_name"
                            :value="data.id">
                            <span style="float: left" v-html="data.staff_name"></span>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div style="margin-top: 10px; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start;">
                <div style="width: 175px; top: 5px; position: relative; ">
                    <span type="label">Notes</span>
                </div>
                <div>
                    <el-input @focus="$event.target.select()"
                        size="small"
                        v-model="$store.state.productionItemIssue.props.notes"
                        style="width: 250px;">
                    </el-input>
                </div>
            </div>
            
        </div>

  </div>
</template>

<script>
export default {
    props: ['rowData'],
    methods: {
        loadSearchedItem($event) {
            
            let loadData = $event
            this.$store.state.productionItemIssue.props.work_order_number = loadData.work_order_number
            this.$store.state.productionItemIssue.props.production_id = loadData.id
            this.$store.state.productionItemIssue.props.tailoring_item_id = loadData.sub_tailoring_item_id && loadData.sub_tailoring_item_id !== null ? loadData.sub_tailoring_item_id : loadData.tailoring_item_id

            this.$store.dispatch('fetchProductionItemIssueData', 
            {
                id: 0, 
                production_id: this.$store.state.productionItemIssue.props.production_id, 
                work_order_number: this.$store.state.productionItemIssue.props.work_order_number,
                tailoring_item_id: this.$store.state.productionItemIssue.props.tailoring_item_id,
                item_issue_mode: true
            })
            
        },
        searchWorkOrderAutoComplete(query) {
            this.$store.dispatch('fetchProductionWorkOrderAutocompleteList', 
            {query: query, customer_id: 0, store_list: this.$store.getters.getAccessibleStoreList})
        }
    },
    mounted() {
        setTimeout(() => {
            if(this.rowData) {
                this.$store.state.productionItemIssue.props.work_order_number = this.rowData.work_order_number
                this.loadSearchedItem(this.rowData)
            }
        }, 1000);
    }
}
</script>

<style scoped>

    
</style>


// WEBPACK FOOTER //
// src/views/ProductionItemIssue/Basic.vue